import * as types from '../types';
import * as erpApi from '@/http/erpApi';
import router from '@/router';
import {
    cmofferApi
} from '@/http/cmofferApi';
import * as api from '@/http/api';
import * as publicApi from '@/http/publicApi';
const state = {
    isCollapse: false,

    systemTime: '',
    systemDate: '',

    statusList: '', //状态列表
    education: '', // 学历列表
    chooseGoodsList: [], // 物品选择列表

    staffList: '', // 员工下拉列表
    roleList: '', // 角色列表

    orderDrawerVisible: false, //orderDrawer visible
    wwwUrl: process.env.VUE_APP_BASE_WWWURL,
    setting: {
        menubar: false,
        toolbar: "fontselect | fontsizeselect | forecolor backcolor | bold italic underline strikethrough | image | link unlink | undo redo | formatselect alignleft aligncenter alignright alignjustify | numlist bullist | table | indent outdent | superscript subscript | paste | removeformat |",
        toolbar_drawer: "sliding",
        quickbars_selection_toolbar: "removeformat | bold italic underline strikethrough | fontsizeselect forecolor backcolor",
        plugins: "link image media table lists fullscreen paste",
        language: "zh_CN", //本地化设置
        height: 320,
        auto_focus: false,
        branding: false,
        link_title: false, //设置插入超链接对话框中“标题”的显示开关
        default_link_target: "_blank", //链接默认打开方式
        fontsize_formats: '11px 12px 14px 16px 18px 24px 36px 48px',
        content_style: "p {font-size:12px}",
        resize: false,
        paste_word_import: 'merge', // 是否保留word粘贴样式  clean | merge   
        paste_data_images: true,
        images_file_types: 'jpeg,jpg,png,gif,bmp,webp',
        images_upload_handler: function (blobInfo, succFun, failFun) {
            const formData = new FormData();
            formData.append("img", blobInfo.blob());
            publicApi.uploadOneImg(formData, "post").then(res => {
                if (res) {
                    succFun(res.data);
                } else {
                    failFun("上传失败")
                }
            });
        },
    },
    tinymceFlag: 1,
    is_infoTags: 'normal',
    goodsSelectdList: [], // 商品选中列表
    orderData: [],
    orderInfo: {},
    // el 时间控件的配置项
    pickerOptions: {
        disabledDate(time) {
            return time.getTime() < Date.now() - 3600 * 1000 * 24;
        }
    },
    screenResolution: 1920,
    menuDrawer: {
        visible: false,
        id: null
    },
    routeObj: {},
};

const mutations = {
    [types.INDEX_COLLAPSE](state, status) {
        state.isCollapse = status;
    },
    [types.SYSTEM_TIME](state, status) {
        state.systemTime = status.sysdate2;
    },
    [types.SYSTEM_DATE](state, status) {
        state.systemDate = status.sysdate;
    },
    [types.STATUS_LIST](state, status) {
        state.statusList = status;
    },
    [types.EDUCATION_LIST](state, status) {
        state.education = status;
    },
    [types.STAFF_LIST](state, status) {
        state.staffList = status;
    },
    [types.MSG_LIST](state, status) {
        state.msgList = status;
    },
    [types.ROLE_LIST](state, status) {
        state.roleList = status;
    },
    [types.INDEX_ORDERDRAWERVISIBLE](state, status) {
        state.orderDrawerVisible = status;
    },
    [types.CHOOSEGOODS_LIST](state, status) {
        state.chooseGoodsList = status;
    },
    [types.WWWURL](state, status) {
        state.wwwUrl = status;
    },
    [types.TINYMCEFLAG](state, status) {
        state.tinymceFlag++;
    },
    [types.IS_INFOTAGS](state, status) {
        state.is_infoTags = status;
    },
    [types.GOODSSELECTED_LIST](state, status) {
        state.goodsSelectdList = status;
    },
    SETORDERDATA(state, val) {
        state.orderData = val;
        sessionStorage.setItem("ORDERDATA", JSON.stringify(val));
    },
    SETORDERINFO(state, val) {
        state.orderInfo = val;
        sessionStorage.setItem("ORDERINFO", JSON.stringify(val));
    },
    SETSCREEN(state, val) {
        state.screenResolution = val;
    },
    SETMENUDRAWERVISIBLE(state, val) {
        state.menuDrawer = {
            ...val
        };
    },
    SETKEYWORD(state, val) {
        state.keyword = val;
    },
    REPLACEQUERY(state, val) {
        state.routeObj.query = val;
        router.replace(state.routeObj)
    }
};

const getters = {

};

const actions = {
    gconf({
        commit,
        dispatch
    }, nameVal) {
        api.gconf({
                name: nameVal
            },
            'get'
        ).then(res => {
            if (res) {
                if (nameVal == 'education') {
                    commit('EDUCATION_LIST', res.data);
                }
            }
        });
    },
    // getSysDate ({ commit, dispatch }) {
    //     erpApi.getSysDate().then(res => {
    //         if (res) {
    //             commit('SYSTEM_TIME', res.bus_json);
    //             commit('SYSTEM_DATE', res.bus_json);
    //         }
    //     });
    // },

    getStaffSelect({
        commit,
        dispatch
    }) {
        erpApi.userSelect({}, 'get').then(res => {
            if (res) {
                commit('STAFF_LIST', res.data);
            }
        });
    },
    getRoleList({
        commit,
        dispatch
    }) {
        erpApi.role({}, 'get').then(res => {
            if (res) {
                commit('ROLE_LIST', res.data);
            }
        });
    },
    getCountrySelect({
        commit,
        dispatch
    }) {
        return new Promise((resolve, reject) => {
            cmofferApi.countrySelect({}, 'get').then(res => {
                if (res) {
                    resolve(res)
                }
            }).catch(err => {
                reject(err)
            });
        })
    },
    shopSelect({
        commit,
        dispatch
    }) {
        return new Promise((resolve, reject) => {
            cmofferApi.shopSelect({}, 'get').then(res => {
                if (res) {
                    resolve(res)
                }
            }).catch(err => {
                reject(err)
            });
        })
    },
    getRntityRankSelect({
        commit,
        dispatch
    }) {
        return new Promise((resolve, reject) => {
            cmofferApi.entityRankSelect({}, 'get').then(res => {
                if (res) {
                    resolve(res)
                }
            }).catch(err => {
                reject(err)
            });
        })
    },
    getBusinessCodeSelect({
        commit,
        dispatch
    }) {
        return new Promise((resolve, reject) => {
            cmofferApi.businessCodeSelect({}, 'get').then(res => {
                if (res) {
                    resolve(res)
                }
            }).catch(err => {
                reject(err)
            });
        })
    },
    getExpressSelect({
        commit,
        dispatch
    }) {
        return new Promise((resolve, reject) => {
            cmofferApi.expressSelect({}, 'get').then(res => {
                if (res) {
                    resolve(res)
                }
            }).catch(err => {
                reject(err)
            });
        })
    },
    getRoleSelect({
        commit,
        dispatch
    }) {
        return new Promise((resolve, reject) => {
            cmofferApi.roleSelect({}, 'get').then(res => {
                if (res) {
                    resolve(res)
                }
            }).catch(err => {
                reject(err)
            });
        })
    },
};

export default {
    state,
    actions,
    getters,
    mutations
};